import type { ReactNode } from "react";
import {
  AllItemsContext,
  AssetsContext,
  TracksContext,
  TransitionsContext,
} from "../../vendor/src/features/remotion-editor/editor/context-provider";
import type { UndoableState } from "../../vendor/src/features/remotion-editor/editor/state/types";

/** Only bars consume the projected graph. Player, actions, persistence and history keep the real document. */
export function IncomingTimelineProjection({
  document,
  children,
}: {
  document: UndoableState | null;
  children: ReactNode;
}) {
  if (!document) return children;
  return (
    <div inert style={{ pointerEvents: "none" }}>
      <TracksContext.Provider value={{ tracks: document.tracks }}>
        <AssetsContext.Provider value={{ assets: document.assets }}>
          <AllItemsContext.Provider value={{ items: document.items }}>
            <TransitionsContext.Provider
              value={{ transitions: document.transitions }}
            >
              {children}
            </TransitionsContext.Provider>
          </AllItemsContext.Provider>
        </AssetsContext.Provider>
      </TracksContext.Provider>
    </div>
  );
}
